import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { BaseService } from '../../../services/base.service';
import { Item } from '../models/item';
import { IDocumentResult } from '../../../base/interfaces/IDocumentResult';
import { Observable } from 'rxjs';
import { IQueryResult } from '../../../base/interfaces/IQueryResult';

@Injectable({
  providedIn: 'root'
})
export class ItemUserService extends BaseService<Item>{

  constructor(
    http: HttpClient,
    @Inject('BASE_URL') rootUrl: string        
  ) { 
    super(http,rootUrl,'TimeTracking/User');
  }
  Last(): Observable<IDocumentResult<Item>> {
    return this.http.get<IDocumentResult<Item>>(`${this.rootUrl}/${this.endpoint}/last`);
  }
  Day(day:Date): Observable<IQueryResult<Item>> {
    let params = {};
    params['dateFilter'] = day;
    return this.http.get<IQueryResult<Item>>(`${this.rootUrl}/${this.endpoint}/day`,{params:params});
  }
  CloseDay(till:Date):Observable<void>{
    let params = {};
    params['till'] = till;    
    return this.http.patch<void>(`${this.rootUrl}/${this.endpoint}/closeDay`,null,{params:params});
  }
  AddType(typeId:string,item:Item):Observable<IQueryResult<Item>>{
    return this.http.post<IQueryResult<Item>>(`${this.rootUrl}/${this.endpoint}/AddType/${typeId}`,item);
  }
}
